import Header from "./header"

import "./upsell.scss"
import iftttLogo from "images/logo-ifttt.svg"
import proBadge from "images/plan-badges/pro.svg"

export interface TrialConfigUrls {
  proSubscriptionsUrl: string
  proPlusSubscriptionsUrl: string
}

export interface TrialConfigAssets {
  proIllustration: string
  proStudentIllustration: string
  eo1Illustration: string
  smartHomeIllustration: string
}
interface Props {
  goal: string
  onSkip: () => void
  onClickBack: () => void
  trialConfig: {
    assets: TrialConfigAssets
    urls: TrialConfigUrls
  }
  userIsStudent: boolean
}

const TITLES = {
  eo1: "Our best business tools",
  smart_home: "Top smart home tools",
  student: "Pro+ student discount",
  default: "Start your trial",
}

const BODIES = {
  eo1: "",
  smart_home: "Make the devices in your home work better together.",
  student:
    "Save 90% on your subscription and get full access to popular Applets and features. Make your favorite things work better together.",
  default:
    "Subscribe to get full access to popular Applets and features. Make your favorite things work better together.",
}

const PERKS = {
  eo1: [
    "Enhance your workflows with AI.",
    "Use multiple actions, queries, and filter code.",
    "Create unlimited Applets.",
    "Your first 7 days are free!",
  ],
  smart_home: [
    "Use multiple actions.",
    "Access exclusive Pro services.",
    "Create up to 20 Applets.",
    "Your first 7 days are free!",
  ],
  student: [
    "Use multiple actions.",
    "Access exclusive Pro services.",
    "Create up to 20 Applets.",
    "Your first 7 days are free!",
  ],
  default: [
    "Use multiple actions.",
    "Access exclusive Pro services.",
    "Create up to 20 Applets.",
    "Your first 7 days are free!",
  ],
}

const BADGE_TIERS = {
  eo1: "pro_plus",
  smart_home: "pro",
  default: "pro",
}

const UPGRADE_URLS = {
  "pro": "proSubscriptionsUrl",
  "pro_plus": "proPlusSubscriptionsUrl",
}

const Upsell = ({ goal, onSkip, trialConfig, onClickBack, userIsStudent }: Props) => {
  let userType = userIsStudent ? "student" : goal
  const illustrations = {
    eo1: {
      url: trialConfig.assets.eo1Illustration,
      alt: "",
    },
    smart_home: {
      url: trialConfig.assets.smartHomeIllustration,
      alt: "",
    },
    student: {
      url: trialConfig.assets.proStudentIllustration,
      alt: "Subscribe to get full access",
    },
    default: {
      url: trialConfig.assets.proIllustration,
      alt: "Try Pro for Free",
    },
  }

  const title = TITLES[userType] || TITLES.default
  let body = BODIES[userType]
  if (body === undefined) {
    body = BODIES.default
  }
  const illustrationUrl = illustrations[userType]?.url || illustrations.default.url
  const illustrationAlt = illustrations[userType]?.alt || illustrations.default.alt
  const perks = PERKS[userType] || PERKS.default
  const badgeTier = BADGE_TIERS[userType] || BADGE_TIERS.default
  const url = trialConfig.urls[UPGRADE_URLS[badgeTier]] || trialConfig.urls.proSubscriptionsUrl

  return (
    <>
      <Header badgeTier={badgeTier} title="" onClickBack={onClickBack} page="trial" />
      <div styleName="container">
        <section styleName="welcome">
          <img src={illustrationUrl} alt={illustrationAlt} />
          <h1>{title}</h1>
          {!!body && <p styleName={body.length && perks.length ? "with-spacer" : ""}>{body}</p>}
          {!!perks.length && (
            <ul styleName="perks">
              {perks.map((perk, i) => (
                <li key={i}>{perk}</li>
              ))}
            </ul>
          )}
        </section>

        <div className="flexbox">
          <section styleName="action-buttons-container" className="action-buttons-container">
            <a href={url} role="button" className="button-primary pay-later" data-dd-action-name="NUI Trial Continue">
              {userIsStudent ? "Claim deal" : "Continue"}
            </a>

            <a onClick={onSkip} styleName="skip-pro-link" data-dd-action-name="NUI Trial Not now">
              Not now
            </a>
          </section>
        </div>
      </div>
    </>
  )
}

export default Upsell
